import React, { MouseEvent, useRef } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar, getElementAtEvent } from 'react-chartjs-2'

import * as S from './styles'
import { numberToCurrency } from '../../../../helpers/helper-currency'
import { useDashboard } from '../../../../contexts/dashboard'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
)

export const layoutOptions = {
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return 'Valor arrecadado'
        },
        label: (context: any) => {
          let label = ''
          if (context.parsed.y) {
            label = numberToCurrency(+context.parsed.y)
          }
          return label
        },
      },
    },
    legend: { display: false },
    title: {
      display: false,
    },
  },
  scales: {
    y: {
      ticks: {
        beginAtZero: false,
        callback(value: any) {
          return numberToCurrency(+value)
        },
      },
    },
  },
}

const SalesChart = ({ data, onToggleBarsInList }: any) => {
  const { windowWidth } = useDashboard()
  const chartRef = useRef<any>()

  const handleChart = (event: MouseEvent<HTMLCanvasElement>) => {
    const currentBar = getElementAtEvent(chartRef.current, event)

    if (currentBar.length > 0) {
      onToggleBarsInList(currentBar[0].index)
    }
  }

  return (
    <S.Container>
      <S.Title>Total Arrecadado</S.Title>
      {
      data && (
        <Bar
          ref={chartRef}
          options={layoutOptions}
          data={data}
          onClick={handleChart}
          width={windowWidth <= 650 ? '100%' : 'auto'}
        />
      )
    }
    </S.Container>
  )
}

export default SalesChart
